import React from "react";
import { IonCol, IonRow } from "@ionic/react";
import { capitalizeString } from "../../../utils/utils";
import { ESTADOS_ASIGNADOS, ESTADOS_CONFIRMADOS } from "../../../utils/constants";
import { CardAsistencia, CardMensajeAviso, InputText } from "app-principal-componentes-visuales";
import "./CasosEnCurso.scss";

const CasosEnCurso = ({ servicios, placeholder, isPrincipal, seleccionados, socio, openSelectGrupoFamiliarModal, handleDetalleCaso }) => {
    return (
        <div className="casos-en-curso">
            <IonRow className='input-padding'>
                <IonCol>
                    <InputText
                        id="datos-contacto-historial-input"
                        cambiarLink
                        label="¿De qué integrante?"
                        onClick={openSelectGrupoFamiliarModal}
                        type="text"
                        value={placeholder}
                        placeholder={placeholder}
                        disable={isPrincipal ?
                            (socio.familiares.length > 0 ? false : true)
                            : false}
                    />
                </IonCol>
            </IonRow>
            {servicios.length === 0 ?
                <>
                    <IonRow>
                        <IonCol size='12'>
                            <CardMensajeAviso
                                alerta
                                id="asistencia-historial-vacio"
                                titulo={seleccionados.length === 1 
                                            ? 'Este socio no posee asistencias en curso.'
                                            : 'Estos socios no poseen asistencias en curso.'
                                }
                            />
                        </IonCol>
                    </IonRow>
                </>
                :
                <IonRow className="card-atenciones-historial">
                    <IonCol size='12'>
                        { servicios.map((servicioEnCurso) => {
                            let fechaCreacion = new Date(servicioEnCurso.fechaCreacion)
                            let mesActual = new Intl.DateTimeFormat('es-ES', { month: 'short' }).format(fechaCreacion);
                            return (
                                (servicioEnCurso.estado !== 'F') && (
                                    <IonRow key={servicioEnCurso?.nroCaso}>
                                        <IonCol>
                                            <CardAsistencia
                                                dia={fechaCreacion.getDate().toString()}
                                                id="asistencia-medica-card-asistencia"
                                                mes={mesActual}
                                                turnos={[
                                                    {
                                                        creada: (ESTADOS_ASIGNADOS.includes(servicioEnCurso.estadoSalus) || servicioEnCurso.estadoSalus === '') ? true : false,
                                                        enEspera: ESTADOS_CONFIRMADOS.includes(servicioEnCurso.estadoSalus) ? true : false,
                                                        onClick: () => { handleDetalleCaso(servicioEnCurso) },
                                                        especialidadPara: servicioEnCurso.descripcion,
                                                        prestador: capitalizeString(servicioEnCurso.principal.nombre + ' ' + servicioEnCurso.principal.apellidos),
                                                        verDetalle: true
                                                    }
                                                ]}
                                            />
                                        </IonCol>
                                    </IonRow>
                                )
                            )
                        })}
                    </IonCol>
                </IonRow>
            }
        </div>
    );
};

export default CasosEnCurso;